import { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc, setDoc, updateDoc, arrayUnion } from 'firebase/firestore';
import { usePopup } from '../../../context/PopupContext';
import { useLoginModal } from '../../../context/LoginModalWrapper';

const db = getFirestore();

const initialFormState = {
  name: '',
  phone: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  pincode: '',
  landmark: '',
  isDefault: false,
};

export const useAddressManagement = (user) => {
    const { openLoginModal } = useLoginModal();

  const { showPopup } = usePopup();
  const [userAddresses, setUserAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showAddressDropdown, setShowAddressDropdown] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [form, setForm] = useState(initialFormState);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const fetchAddresses = async () => {
      if (!user) return;
      try {
        const docRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(docRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          const addresses = data.address || [];
          setUserAddresses(addresses);
          const defaultAddr = addresses.find((a) => a.isDefault) || addresses[0] || null;
          setSelectedAddress(defaultAddr);
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      }
    };
    fetchAddresses();
  }, [user, showAddressForm]);

  const handleAddressChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    if (!user) {
      // alert('Please login to save addresses');
      showPopup('Please login to save addresses');
      openLoginModal();
      return;
    }

    setIsProcessing(true);
    try {
      const userRef = doc(db, 'users', user.uid);
      const newAddress = {
        ...form,
        createdAt: new Date().toISOString(),
      };

      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) {
        await setDoc(userRef, {
          address: [newAddress],
          userId: user.uid,
          createdAt: new Date().toISOString()
        });
      } else {
        await updateDoc(userRef, {
          address: arrayUnion(newAddress)
        });
      }

      setShowAddressForm(false);
      setForm(initialFormState);
      
      const updatedSnap = await getDoc(userRef);
      if (updatedSnap.exists()) {
        const data = updatedSnap.data();
        setUserAddresses(data.address || []);
        setSelectedAddress(data.address.find(a => a.isDefault) || data.address[0] || null);
      }
    } catch (error) {
      console.error("Error saving address:", error);
      // alert('Failed to save address. Please try again.');
      showPopup('Failed to save address. Please try again.');

    } finally {
      setIsProcessing(false);
    }
  };

  return {
    userAddresses,
    selectedAddress,
    showAddressDropdown,
    showAddressForm,
    form,
    setSelectedAddress,
    setShowAddressDropdown,
    setShowAddressForm,
    setForm,
    handleAddressChange,
    handleAddressSubmit,
    isProcessing
  };
};